import React, {useEffect} from 'react';
import {Drawer} from 'app/components/sidebar/Drawer';
import {UserMenu} from 'app/components/sidebar/UserMenu';
import {Backdrop} from '@mui/material';
const animationDuration = 150;

const Sidebar = ({open, onClose, anchorEl}) => {
  const lockScroll = () => (document.body.style.overflow = 'hidden');
  const unlockScroll = () => (document.body.style.overflow = null);

  useEffect(() => {
    if (open) {
      lockScroll();
    } else {
      unlockScroll();
    }
  }, [open]);

  return (
    <Backdrop
      sx={theme => ({
        zIndex: theme.zIndex.backdrop,
        backgroundColor: 'rgba(256, 256, 256, 0.6)',
        [theme.breakpoints.up('md')]: {
          width: 0,
          height: 0,
          overflow: 'visible',
        },
      })}
      open={open}
      transitionDuration={animationDuration}>
      <Drawer
        anchorEl={anchorEl}
        onClose={onClose}
        hide={!open}
        onClick={e => e.stopPropagation()}
        animationDuration={animationDuration}>
        <UserMenu animationDuration={animationDuration} closeDialog={onClose} />
      </Drawer>
    </Backdrop>
  );
};

export default Sidebar;
